module.exports = __webpack_public_path__ + "img/image-01.a8fb7498.webp";